import axios from 'axios';

const state = {
  servicioExternos: [],
};

const mutations = {
  SET_SERVICIOEXTERNOS(state, servicioExternos) {
    state.servicioExternos = servicioExternos;
  },
  ADD_SERVICIOEXTERNO(state, servicioExterno) {
    state.servicioExternos.push(servicioExterno);
  },
  UPDATE_SERVICIOEXTERNO(state, servicioExterno) {
    const index = state.servicioExternos.findIndex(s => s.id === servicioExterno.id);
    if (index !== -1) {
      state.servicioExternos.splice(index, 1, servicioExterno);
    }
  },
  DELETE_SERVICIOEXTERNO(state, servicioExternoId) {
    state.servicioExternos = state.servicioExternos.filter(s => s.id !== servicioExternoId);
  },
};

const actions = {
  async fetchServicioExternos({ commit }) {
    try {
      const response = await axios.get('/api/servicioexterno');
      commit('SET_SERVICIOEXTERNOS', response.data);
    } catch (error) {
      console.error('Error fetching servicio externos:', error);
      throw error;
    }
  },
  async createServicioExterno({ commit }, servicioExterno) {
    try {
      const response = await axios.post('/api/servicioexterno', servicioExterno);
      commit('ADD_SERVICIOEXTERNO', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating servicio externo:', error);
      throw error;
    }
  },
  async updateServicioExterno({ commit }, servicioExterno) {
    try {
      const response = await axios.put(`/api/servicioexterno/${servicioExterno.id}`, servicioExterno);
      commit('UPDATE_SERVICIOEXTERNO', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating servicio externo:', error);
      throw error;
    }
  },
  async deleteServicioExterno({ commit }, servicioExternoId) {
    try {
      await axios.delete(`/api/servicioexterno/${servicioExternoId}`);
      commit('DELETE_SERVICIOEXTERNO', servicioExternoId);
    } catch (error) {
      console.error('Error deleting servicio externo:', error);
      throw error;
    }
  },
};

const getters = {
  servicioExternos: state => state.servicioExternos,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
